import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  error: null,
  success: false,
};

export const discountSlice = createSlice({
  name: 'discount',
  initialState,
  reducers: {
    discountCodeFailure: (state, actions) => {
      state.success = false;
      state.error = actions.payload;
    },
    discountCodeSuccess: (state) => {
      state.success = true;
      state.error = null;
    },
    reset: (state) => {
      state.error = null;
      state.success = false;
    },
  },
});

export const selectDiscount = (state) => {
  return state.discount;
};

export const { discountCodeFailure, discountCodeSuccess } = discountSlice.actions;

export default discountSlice.reducer;
